// Phase A3 (gates A3.1 to A3.3): the cast from their cards on @rpg/figure, in @rpg/look's low-poly look, shown in the
// figure lab (`?scene=figure`). main.ts calls `figureLabFor` and joins `figureFaults` into the spike's faults record.
import type { Rapier } from "@rpg/collision";
import type { Runtime } from "@rpg/runtime";
import type * as THREE from "three";
import type { SpikeContent } from "../content";
import { applyFigureFaultSwitches } from "./faults";
import { mountFigureLab, type FigureLab } from "./lab";

export { FIGURE_FAULT_NAMES, figureFaults } from "./faults";
export type { FigureLab } from "./lab";
export type { FigureDriver } from "./locomotion";

/** The lab when the page asks for it (`?scene=figure`), else null. The tier is the boot shell's. */
export function figureLabFor(search: string, o: { runtime: Runtime; renderer: THREE.WebGLRenderer; rapier: Rapier; content: SpikeContent; tier: string }): FigureLab | null {
  applyFigureFaultSwitches(search);
  if (new URLSearchParams(search).get("scene") !== "figure") return null;
  return mountFigureLab({ runtime: o.runtime, renderer: o.renderer, rapier: o.rapier, registry: o.content.registry, tier: o.tier });
}
